/* eslint-disable no-unused-vars */
import { OneOnOneTeamRoleType } from "@teaming/common-enums";

export const pristineNewOneOnOneState = i18n => {
	return {
		canValidate: false,
		deferInvitation: false,
		errors: {},
		isValid: true,
		isVisible: false,
		teammateEmail: "",
		teammateRole: OneOnOneTeamRoleType.REPORT,
		teammatesByEmail: {},
		teammateMatches: [],
	};
};

export const pristineState = i18n => ( {
	isConfirmationDialogOpen: false,
	options: {},
	newOneOnOneDialog: {
		...pristineNewOneOnOneState( i18n ),
	},
} );
